import { combineReducers } from "redux";
import configSlice from "./configSlice";
import chatSlice from "./chatSlice";

export default combineReducers({
  root: configSlice.reducer,
  chat: chatSlice.reducer,
});
